<template>
  <div>
    <b-modal id="modalEditBanks" ref="modalEditBanks" :title="$t('New bank')" hide-footer>
      <div v-if="editItem">
          <b-form-group label-align="right" label='ID' label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.bank_id">
            <b-form-input type="text" disabled v-model="editItem.bank_id"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('BIN')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="editItem.bic" :disabled="editItem.bank_id > 0"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
            <b-form-invalid-feedback id="inputFeedbackName">
                {{ $t('Enter title') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('City')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="editItem.city" aria-describedby="inputFeedbackCity" :state="editItem.city.length > 0"/>
            <b-form-invalid-feedback id="inputFeedbackCity">
                {{ $t('Enter title') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Correspondent account')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="editItem.kschet"/>
          </b-form-group>

          <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditBanks')"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  methods: {
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field Name'), 'Error')
        return
      }
      if (!this.editItem.city) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field City'), 'Error')
        return
      }

      let response = this.editItem.bank_id !== 0
        ? this.$store.dispatch('ReferenceBooks/UPDATE_BANKS', this.editItem)
        : this.$store.dispatch('ReferenceBooks/CREATE_BANKS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$emit('loadBanks')
          this.$refs.modalEditBanks.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/banks/editModal.vue